module.exports = __webpack_public_path__ + "static/media/УОМШ-2020 Программа конференции.c1dac52e.pdf";